import React from "react";
import dayjs from "dayjs";
import { Box, Typography, Stack } from "@mui/material";
import { grey } from "@mui/material/colors";
import { defaultStyle } from "components/Modals";
import { ProductionParkLimitationTypes } from "helpers/enums";
import Table from "components/Table";

interface ChangeHistoryModalProps {
  limitation: any;
}

const ChangeHistoryModal = ({ limitation }: ChangeHistoryModalProps) => {
  const columns = [
    {
      accessorKey: "changeType",
      header: "Operation",
    },
    {
      accessorKey: "toDatetime",
      header: "To",
      cell: (row: any) => {
        return `${dayjs(row.row.original.toDatetime).format(
          "DD.MM.YYYY HH:mm",
        )}`;
      },
    },
    {
      accessorKey: "modifiedAt",
      header: "Modified at",
      cell: (row: any) => {
        const time =
          row.row.original.changeType === "CREATED"
            ? row.row.original.createdAt
            : row.row.original.modifiedAt;

        return `${dayjs(time).format("DD.MM.YYYY HH:mm")}`;
      },
    },
    {
      accessorKey: "modifiedBy",
      header: "Modified by",
    },
  ];

  return (
    <Box sx={defaultStyle}>
      <Typography id="modal-modal-title" variant="h5" component="h5">
        Change history
      </Typography>
      <Typography
        id="modal-modal-title"
        component="p"
        sx={{ color: grey[700], mt: "0.6rem" }}
      >
        The change history for the selected limitation.
      </Typography>
      <Box sx={{ mt: 2 }}>
        <Stack direction="row" spacing={4}>
          <Typography component="p">
            <strong>Type:</strong>{" "}
            {
              ProductionParkLimitationTypes[
                limitation.type as keyof typeof ProductionParkLimitationTypes
              ]
            }
          </Typography>
          <Typography component="p">
            <strong>Value:</strong>{" "}
            {`${limitation.type === "MAX_OUTPUT" ? limitation.value : limitation.value * 100}`}
            {limitation.type === "MAX_OUTPUT" ? " kW" : "%"}
          </Typography>
          <Typography component="p">
            <strong>From:</strong>{" "}
            {dayjs(limitation.fromDateTime).format("DD.MM.YYYY HH:mm")}
          </Typography>
        </Stack>
        <Table
          dense
          data={limitation.changeHistory}
          isFetching={!limitation}
          columns={columns}
        />
      </Box>
    </Box>
  );
};

export default ChangeHistoryModal;
